import {
    DueInvoiceIdealDetailInterface, InvoiceAdvanceInterface, Message,
    TotaalFacturenFactuurInterface, VaststellingFactuurVerrekeningInterface,
} from '@app/core/interfaces';
import * as fromInvoices from './invoices.actions';

/** @deprecated moved to libs folder */
export interface State {
    entities: { [factuur_id: string]: TotaalFacturenFactuurInterface };
    payments: { [factuur_id: string]: DueInvoiceIdealDetailInterface };
    calculations: { [factuur_id: string]: VaststellingFactuurVerrekeningInterface };
    advances: { [factuur_id: string]: InvoiceAdvanceInterface };
    years: number[];
    ids: string[];
    selectedYear: number;
    selectedId: string;
    loading: boolean;
    formLoading: boolean;
    loadedYears: number[];
    loadedInvoices: string[];
    errors: Message[];
    toPayIdeal: number;
    toPayOnline: number;
}

/** @deprecated moved to libs folder */
export const initialState: State = {
    entities: {},
    payments: {},
    calculations: {},
    advances: {},
    years: [],
    ids: [],
    selectedYear: null,
    selectedId: null,
    loading: false,
    formLoading: false,
    loadedYears: [],
    loadedInvoices: [],
    errors: [],
    toPayIdeal: null,
    toPayOnline: null,
};

function invoiceReducer<T>(entities: { [factuur_id: string]: T }, entity: T): { [factuur_id: string]: T } {
    const factuur_id = entity['factuur_id'] as string;

    return Object.assign({}, entities, {
        [factuur_id]: Object.assign({}, entities[factuur_id] || {}, entity),
    });
}

function filterDuplicates<T>(arr: T[]): T[] {
    return Array.from(new Set([...arr]));
}

/** @deprecated moved to libs folder */
export function reducer(state: State = initialState, action: fromInvoices.InvoicesActions): State {
    switch (action.type) {
        case fromInvoices.LOAD_INVOICES: {
            return {
                ...state,
                loading: true,
            };
        }

        case fromInvoices.LOAD_INVOICES_SUCCESS: {
            if (!action.payload.totaal_factuur) {
                return state;
            }

            const totaal_factuur = action.payload.totaal_factuur;
            const invoices = totaal_factuur.factuur || [];
            const invoice_years = totaal_factuur.jaartallen.jaartal || [];
            const selected_year = totaal_factuur.jaartallen.geselecteerd;

            const ids: string[] = invoices.map((invoice) => invoice.factuur_id);
            const years: number[] = invoice_years.map((jaartal) => jaartal.jaar);

            let payments: DueInvoiceIdealDetailInterface[];

            if (totaal_factuur.te_betalen_ideal) {
                payments = totaal_factuur.te_betalen_ideal.detail;
            } else if (totaal_factuur.te_betalen_online) {
                payments = totaal_factuur.te_betalen_online.detail;
            } else {
                payments = [];
            }

            return {
                ...state,
                entities: Object.assign({},
                    invoices.reduce<{ [id: string]: TotaalFacturenFactuurInterface }>(invoiceReducer, state.entities),
                ),
                payments: Object.assign({},
                    payments.reduce<{ [id: string]: DueInvoiceIdealDetailInterface }>(invoiceReducer, state.payments),
                ),
                loading: false,
                selectedYear: selected_year,
                ids: filterDuplicates<string>([...state.ids, ...ids]),
                years: filterDuplicates<number>([...state.years, ...years]),
                loadedYears: filterDuplicates<number>([...state.loadedYears, selected_year]),
                toPayIdeal: totaal_factuur?.te_betalen_ideal?.bedrag ?? null,
                toPayOnline: totaal_factuur?.te_betalen_online?.bedrag ?? null,
            };
        }

        case fromInvoices.LOAD_INVOICE_DETAIL: {
            return {
                ...state,
                loading: true,
            };
        }

        case fromInvoices.LOAD_INVOICE_DETAIL_SUCCESS: {
            const detail_factuur = action.payload.detail_factuur;
            const factuur_id = detail_factuur.factuur.factuur_id;

            const entity = state.entities[factuur_id] || {};
            const calculation = state.calculations[factuur_id] || {};
            const advance = state.advances[factuur_id] || {};

            return {
                ...state,
                entities: Object.assign({}, state.entities, {
                    [factuur_id]: Object.assign({}, entity, detail_factuur.factuur),
                }),
                calculations: Object.assign({}, state.calculations, {
                    [factuur_id]: Object.assign({}, calculation, detail_factuur.verrekening),
                }),
                advances: Object.assign({}, state.advances, {
                    [factuur_id]: Object.assign({}, advance, detail_factuur.voorschot),
                }),
                loading: false,
                loadedInvoices: filterDuplicates([...state.loadedInvoices, factuur_id]),
            };
        }

        case fromInvoices.SET_SELECTED_ID: {
            if (!action.payload.factuur_id) {
                return state;
            }

            return {
                ...state,
                selectedId: action.payload.factuur_id,
            };
        }

        case fromInvoices.SET_SELECTED_YEAR: {
            if (!action.payload.jaartal) {
                return state;
            }

            return {
                ...state,
                selectedYear: action.payload.jaartal,
            };
        }

        case fromInvoices.SET_PAYMENT: {
            return {
                ...state,
                formLoading: true,
                errors: [],
            };
        }

        case fromInvoices.SET_PAYMENT_SUCCESS: {
            return {
                ...state,
                formLoading: false,
            };
        }

        case fromInvoices.SET_ERROR: {
            return {
                ...state,
                loading: false,
                formLoading: false,
                errors: action.payload.errors,
            };
        }

        case fromInvoices.CLEAR_ERROR: {
            return {
                ...state,
                errors: [],
            };
        }

        case fromInvoices.LOADING_DONE: {
            return {
                ...state,
                loading: false,
            };
        }

        default: {
            return state;
        }
    }
}

/* selectors */
/** @deprecated moved to libs folder */
export const getInvoiceEntities = (state: State) => state.entities;
/** @deprecated moved to libs folder */
export const getInvoicePayments = (state: State) => state.payments;
/** @deprecated moved to libs folder */
export const getInvoiceCalculations = (state: State) => state.calculations;
/** @deprecated moved to libs folder */
export const getInvoiceAdvances = (state: State) => state.advances;
/** @deprecated moved to libs folder */
export const getInvoiceYears = (state: State) => state.years;
/** @deprecated moved to libs folder */
export const getInvoiceSelectedYear = (state: State) => state.selectedYear;
/** @deprecated moved to libs folder */
export const getInvoiceIds = (state: State) => state.ids;
/** @deprecated moved to libs folder */
export const getInvoiceLoading = (state: State) => state.loading;
/** @deprecated moved to libs folder */
export const getInvoiceFormLoading = (state: State) => state.formLoading;
/** @deprecated moved to libs folder */
export const getLoadedInvoices = (state: State) => state.loadedInvoices;
/** @deprecated moved to libs folder */
export const getLoadedYears = (state: State) => state.loadedYears;
/** @deprecated moved to libs folder */
export const getInvoiceId = (state: State) => state.selectedId;
/** @deprecated moved to libs folder */
export const getInvoiceErrors = (state: State) => state.errors;
export const getToPayIdeal = (state: State) => state.toPayIdeal;
export const getToPayOnline = (state: State) => state.toPayOnline;
